import React, { useState, useEffect, useContext } from 'react';
import BarraLateral from './BarraLateral';
import AlertaCobranza from './AlertaCobranza';
import BloqueoCobranzaModal from './BloqueoCobranzaModal';
import { AuthContext } from '../context/AuthContext';
import cobranzasService from '../services/cobranzasService';

const Diseno = ({ children }) => {
    const { user, logout } = useContext(AuthContext);
    const [cobranzaStatus, setCobranzaStatus] = useState(null);
    const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);

    const isExemptRole = user?.role_details?.name === 'GESTOR_COBRANZAS';

    const fetchCobranzaStatus = async () => {
        if (!user || isExemptRole) return;
        try {
            const data = await cobranzasService.getMyStatus();
            setCobranzaStatus(data);
        } catch (error) {
            console.error('Error obteniendo estado de cobranza:', error);
        }
    };

    useEffect(() => {
        fetchCobranzaStatus();
    }, [user]);

    const isBlocked = !isExemptRole && Boolean(cobranzaStatus?.is_blocked);
    const showUploadModal = isBlocked || isUploadModalOpen;

    const handleSuccessUpload = async (res) => {
        setIsUploadModalOpen(false);
        try {
            const data = await cobranzasService.getMyStatus();
            setCobranzaStatus(data);
        } catch (err) {
            console.error('Error refrescando estado de cobranza:', err);
        }
    };

    return (
        <div className="layout">
            <BarraLateral />
            <main className="main-content">
                {/* Banner de Aviso de Pago (Días 1-5 o En Revisión) */}
                {!isExemptRole && (
                    <AlertaCobranza
                        cobranzaStatus={cobranzaStatus}
                        onOpenUploadModal={() => setIsUploadModalOpen(true)}
                    />
                )}

                {/* Contenido de la página */}
                {children}

                {/* Modal de Bloqueo / Subida de Comprobante */}
                {!isExemptRole && (
                    <BloqueoCobranzaModal
                        isOpen={showUploadModal}
                        isBlocked={isBlocked}
                        cobranzaStatus={cobranzaStatus}
                        onClose={() => setIsUploadModalOpen(false)}
                        onSuccessUpload={handleSuccessUpload}
                        onLogout={logout}
                    />
                )}
            </main>
        </div>
    );
};

export default Diseno;